const DEVICES = [
  'console', 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded'
] as const

type TValidDevice = typeof DEVICES[number]

export type TDevice = TValidDevice | undefined

export const IOS_OSS = [ 'ios' ] as const

export const MAC_OS_OSS = [ 'mac os' ] as const

export const APPLE_OSS = [
  ...IOS_OSS, ...MAC_OS_OSS
] as const

export const WINDOWS_OSS = [
  'windows', 'windows phone', 'windows mobile', 'windows phone os'
] as const

export const LINUX_OSS = [
  'aix', 'arch', 'unix', 'linux', 'debian', 'ubuntu', 'vectorlinux', 'fedora',
  'gentoo', 'centos', 'freebsd', 'openbsd', 'pclinuxos', 'gnu', 'haiku', 'mageia',
  'mandriva', 'minix', 'mint', 'netbsd', 'redhat', 'meego', 'dragonfly', 'slackware',
  'solaris', 'suse', 'tizen', 'zenwalk', 'sailfish', 'hurd', 'joli',
  'linpus', 'qnx', 'firefox os', 'webos'
] as const

export const ANDROID_OSS = [
  'android'
] as const

export const OSS = [
  ...APPLE_OSS,
  ...LINUX_OSS,
  ...ANDROID_OSS,
  ...WINDOWS_OSS,
  'amiga os', 'bada', 'beos', 'blackberry', 'chromium os', 'contiki',
  'morph os', 'nintendo', 'openvms', 'os/2', 'palm', 'plan9',
  'playstation', 'rim tablet os', 'risc os', 'series40',
  'symbian'
] as const

type TValidOs = typeof OSS[number]

export type TOs = TValidOs | undefined

export const CHROME_BROWSERS = [
  'chrome headless', 'chrome webview', 'chrome', 'chromium'
] as const

export const FF_BROWSERS = [
  'mozilla', 'firefox'
] as const

export const EDGE_BROWSERS = [
  'edge'
] as const

export const IE_BROWSERS = [
  'ie', 'iemobile'
] as const

export const OPERA_BROWSERS = [
  'opera coast', 'opera mini', 'opera mobi', 'opera tablet'
] as const

export const SAFARI_BROWSERS = [
  'safari'
] as const

export const BROWSERS = [
  ...FF_BROWSERS,
  ...IE_BROWSERS,
  ...EDGE_BROWSERS,
  ...OPERA_BROWSERS,
  ...CHROME_BROWSERS,
  ...SAFARI_BROWSERS,
  '2345explorer', '360 browser', 'amaya', 'android browser', 'arora', 'avant', 'avast', 'avg',
  'bidubrowser', 'baidu', 'basilisk', 'blazer', 'bolt', 'brave', 'bowser', 'camino', 'chimera',
  'comodo dragon', 'dillo', 'dolphin', 'doris', 'duckduckgo', 'electron', 'epiphany', 'facebook',
  'falkon', 'fennec', 'firebird', 'flock', 'flow', 'gsa', 'gobrowser', 'huawei browser',
  'ice browser', 'iceape', 'icecat', 'icedragon', 'iceweasel', 'instagram', 'iridium', 'iron',
  'jasmine', 'k-meleon', 'kindle', 'klar', 'konqueror', 'lbbrowser', 'line', 'linkedin', 'links',
  'lunascape', 'lynx', 'miui browser', 'maemo browser', 'maemo', 'maxthon', 'metasr midori', 'minimo',
  'mobile safari', 'mosaic', 'netfront', 'netsurf', 'netfront', 'netscape', 'nokiabrowser', 'obigo',
  'oculus browser', 'omniweb', 'palemoon', 'phantomjs', 'phoenix', 'polaris', 'puffin', 'qq', 'qqbrowser',
  'qqbrowserlite', 'quark', 'qupzilla', 'rockmelt', 'sailfish browser', 'Samsung Internet', 'seamonkey', 'silk',
  'skyfire', 'sleipnir', 'slim', 'slimbrowser', 'swiftfox', 'tesla', 'tizen browser', 'ucbrowser', 'up.browser',
  'vivaldi', 'waterfox', 'wechat', 'weibo', 'yandex', 'baidu', 'icab', 'w3m', 'whale browser'
] as const

type TValidBrowsers = typeof BROWSERS[number]

export type TBrowser = TValidBrowsers | undefined

export type { IResult } from 'ua-parser-js'
